/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import Sidebar from "../components/Sidebar";
import { useQuery } from "@tanstack/react-query";
import MobileSidebar from "../components/MobileSidebar";
import axios from "axios";
import { BASE_URL } from "../config/config";

// format date function and get time and date separately
const formatDate = (date) => {
  const d = new Date(date);
  const time = d.toLocaleTimeString();
  const dateStr = d.toDateString();
  return { time, dateStr };
};

const Home = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const accessToken = localStorage.getItem("accessToken");

  const { data: planDetails, refetch } = useQuery({
    queryKey: ["planDetails", { userId: user?._id }],
    queryFn: async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/auth/user-plan/${user?._id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const res = response.data;
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    enabled: !!user && !!accessToken,
  });

  React.useEffect(() => {
    if (!planDetails) {
      refetch();
    }
  }, [planDetails]);

  return (
    <div className="md:flex justify-between items-start min-h-[100vh] max-w-[100vw]">
      <Sidebar />
      <MobileSidebar />
      <div className="md:ml-[18vw] w-[100%] md:p-9 p-3 relative ">
        <h1 className="font-gabarito font-medium text-left text-[40px] text-[#333333]">
          Dashboard
        </h1>
        <div className="bg-white p-4 w-full rounded-lg shadow-md ">
          <h1 className="font-gabarito text-left font-medium text-2xl text-[#333333]">
            Welcome {user?.firstName}
          </h1>
          <p className="font-gabarito font-normal text-left text-[16px] text-[#333333] mt-2">
            {user?.email}
          </p>
        </div>
        <div className="md:flex justify-between items-center mt-6">
          <div className="md:w-[49%] w-full bg-white p-4 rounded-lg shadow-md  flex flex-col items-start justify-end">
            <h1 className="font-gabarito font-medium text-[20px] text-[#333333]">
              Plan: {planDetails?.plan.name}
            </h1>
            <p className="font-gabarito font-normal text-[16px] text-[#333333] mt-2">
              Plan Duration: {planDetails?.plan.duration}
            </p>
            <p className="font-gabarito font-normal text-[16px] text-[#333333] mt-2">
              Paid Amount: ${planDetails?.plan.price}
            </p>
          </div>
          <div className="md:w-[49%] md:mt-0 mt-6 w-full bg-white p-4 rounded-lg shadow-md  flex flex-col items-start justify-end">
            <h1 className="font-gabarito font-medium text-[20px] text-[#333333]">
              Subscription Status:{" "}
              {planDetails?.user.subscriptionStatus.toUpperCase()}
            </h1>
            <p className="font-gabarito font-normal text-[16px] text-[#333333] mt-2">
              Till Day:{" "}
              {formatDate(planDetails?.user.subscriptionEndDate).dateStr}
            </p>
            <p className="font-gabarito font-normal text-[16px] text-[#333333] mt-2">
              Until: {formatDate(planDetails?.user.subscriptionEndDate).time}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-md mt-6">
          <p className="font-gabarito text-left text-[20px] font-medium text-[#333333] mt-2">
            Features:
          </p>
          <ul className="font-gabarito font-normal text-[16px] text-[#333333] mt-2 flex flex-col items-start list-disc pl-4">
            {planDetails?.plan.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
